export default __webpack_public_path__ + "static/card1-79c9b9ef30969f16ea5ba95b497b2542.png";